/* eslint-disable */
// @ts-nocheck
import React from 'react'
import {
  Button,
  Flex,
  Heading,
  List,
  ListItem,
  Text,
  VStack,
  Card,
  CardBody,
  Divider,
  CardHeader,
  CardFooter,
  ButtonGroup,
  Stack,
  HStack,
  Box,
  keyframes,
  Grid,
  GridItem,
} from '@chakra-ui/react'
import { PhoneIcon } from '@chakra-ui/icons'
import { isWeekend, parse } from 'date-fns'

const AllReservations = ({
  reservations,
  dates,
  onSetEditingReservation,
}: {
  reservations: any[]
  dates: null | Array<string>
  onSetEditingReservation: (reservation: any) => void
}) => {
  if (reservations.length === 0) {
    return (
      <VStack alignItems='flex-start' spacing={4}>
        <Text>No reservations found</Text>
      </VStack>
    )
  }

  if (!dates || dates.length === 0) {
    return (
      <VStack alignItems='flex-start' spacing={4}>
        <Text>No dates</Text>
      </VStack>
    )
  }
  const longestArrayKey = Object.keys(reservations).reduce((maxKey: string, currentKey) => {
    return reservations[currentKey].length > reservations[maxKey].length ? currentKey : maxKey
  }, Object.keys(reservations)[0])
  const longestNumber = reservations[longestArrayKey].length

  const reservationBg = (reservation) => {
    if (reservation.inquiry === 1) {
      return 'yellow.800'
    }

    if (reservation.inquiry) {
      return 'yellow.800'
    } else if (reservation.tasting) {
      return 'orange.300'
    }

    if (reservation.type === 'localReservation') {
      return 'blue.800'
    }

    return 'green.500'
  }

  const shownReservations = []
  const renderForDateAndInfex = (date: string, index: number) => {
    const dateToUse = date.date
    if (!reservations.hasOwnProperty(dateToUse)) {
      return (
        <GridItem key={`${dateToUse}-${index}-no`} bg='white' p={0} position='relative'></GridItem>
      )
    }

    // reservation that is not already in shownReservations array by key identifier
    const reservationToRender = reservations[dateToUse].find(
      (reservation: any) => !shownReservations.includes(reservation.identifier),
    )
    if (!reservationToRender) {
      return (
        <GridItem key={`${dateToUse}-${index}-no`} bg='white' p={0} position='relative'></GridItem>
      )
    }
    shownReservations.push(reservationToRender.identifier)

    return (
      <GridItem
        key={`${dateToUse}-${index}-yes`}
        p={2}
        bg={reservationBg(reservationToRender)}
        borderWidth={1}
        cursor={reservationToRender.id ? 'pointer' : 'default'}
        onClick={() => reservationToRender.id ? onSetEditingReservation(reservationToRender) : null}
      >
        <VStack alignItems='center' justifyContent='center' spacing={1}>
          <Text fontSize='sm' fontWeight='bold' color='white' lineHeight='1rem'>
            {reservationToRender.name ?? 'No name'} @ {reservationToRender.time ?? 'No time'}
          </Text>
          <VStack>
            <HStack>
              <Text fontSize='xs' bg='red.500' color='white' px={1.5} borderRadius={4}>
                {reservationToRender.location ?? '-'}
              </Text>
              <Text fontSize='xs' bg='purple.500' color='white' px={1.5} borderRadius={4}>
                {reservationToRender.guests ?? '-'}
              </Text>
            </HStack>
            <Text fontSize='xs' bg='blue.500' color='white' px={1.5} borderRadius={4}>
              {reservationToRender.phone ?? 'No phone'}
            </Text>
          </VStack>
        </VStack>
      </GridItem>
    )
  }
  return (
    <VStack spacing={4} alignItems='flex-start' p={4} width='100%' overflowX='auto'>
      <Box>
        <Grid templateColumns={`repeat(${dates.length}, minmax(200px, 1fr))`} gap={1} px={4}>
          {dates.map((date, index) => (
            <GridItem
              key={index}
              bg={
                isWeekend(parse((date as any).date, 'yyyy-MM-dd', new Date()))
                  ? 'gray.300'
                  : 'gray.100'
              }
              p={2}
              position='relative'
            >
              <HStack align='center' justify='center'>
                <Text>{(date as any).name.substring(0, 3)}</Text>
                <Text>{(date as any).date || 'Date'}</Text>
              </HStack>
            </GridItem>
          ))}
          {Array.from({ length: longestNumber }, (_, i) => i).map((_, rowIndex) =>
            dates.map((date, index) => renderForDateAndInfex(date, rowIndex)),
          )}
        </Grid>
      </Box>
    </VStack>
  )
}

export default AllReservations
